export const testy = () => {
    console.log("Function is working")
}

export const testyz = () => {
    console.log("checking twice")
}

// export default {testy,testyz}
